import type from '../commons/appointmentActionStatus';

const DEFAULT_STATE = {
    error: null,
    requestState: false,
    status: null,
    appointmentCreated: {}
};

export const appointmentReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let appointmentCreated;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    switch (actionType) {

        case type.CREATE_APPOINTMENT_REQUEST:
            return { ...state, requestState, status };

        case type.CREATE_APPOINTMENT_SUCCESS:
            appointmentCreated = action.result;
            return {
                ...state,
                appointmentCreated,
                requestState,
                status,
            };

        case type.CREATE_APPOINTMENT_FAILURE:
            return { ...state, error, requestState, status };

        case type.RESET_APPOINTMENT_STATE:
            return {
                ...state,
                error: null,
                status: null,
                appointmentCreated: {},
            };

        default:
            return state;
    }
};
